import { useEffect, useState } from 'react';

import { isAppWebviewUserAgent } from '~/utilities/helpers/isAppWebviewUserAgent';

export const useIsAppWebview = () => {
  const [isAppWebview, setIsAppWebview] = useState(false);

  useEffect(() => {
    const isAppUserAgent = isAppWebviewUserAgent(window.navigator.userAgent);

    setIsAppWebview(isAppUserAgent);
  }, []);

  return isAppWebview;
};
